let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ktbv9")).then(() => parcelRequire('3tum0'));